import urljoin from 'url-join';
import { EmbedConfig } from '../..';
import render from '../../designs/paper';

import signifierWoff2 from '../../../../../../client/assets/Signifier-Medium.woff2';
import signifierWoff from '../../../../../../client/assets/Signifier-Medium.woff';
import signifierBoldWoff2 from '../../../../../../client/assets/Signifier-Bold.woff2';
import signifierBoldWoff from '../../../../../../client/assets/Signifier-Bold.woff';
import petitSerifWoff2 from '../../../../../../client/assets/PetitSerif.woff2';
import petitSerifWoff from '../../../../../../client/assets/PetitSerif.woff';

import './styles/style.scss';

const additionalFonts = (config: EmbedConfig) => {
  const signifierWoff2Path = urljoin(config.goBaseUrl, signifierWoff2);
  const signifierWoffPath = urljoin(config.goBaseUrl, signifierWoff);

  const signifierBoldWoff2Path = urljoin(config.goBaseUrl, signifierBoldWoff2);
  const signifierBoldWoffPath = urljoin(config.goBaseUrl, signifierBoldWoff);

  const petitSerifWoff2Path = urljoin(config.goBaseUrl, petitSerifWoff2);
  const petitSerifWoffPath = urljoin(config.goBaseUrl, petitSerifWoff);

  return `
    @font-face {
      font-family: 'Signifier';
      font-style: normal;
      src: url('${signifierWoff2Path}') format('woff2'),
        url('${signifierWoffPath}') format('woff');
    }

    @font-face {
      font-family: 'Signifier';
      font-style: normal;
      font-weight: 700;
      src: url('${signifierBoldWoff2Path}') format('woff2'),
        url('${signifierBoldWoffPath}') format('woff');
    }

    @font-face {
      font-family: 'Petit Serif';
      font-style: normal;
      src: url('${petitSerifWoff2Path}') format('woff2'),
        url('${petitSerifWoffPath}') format('woff');
    }`;
};

render(additionalFonts);
